//import axios from "axios";
import sesionService from '@/services/SesionService';
import autenticacionService from '@/services/AutenticacionService';

export default {
	state: {
		user: null,
		error: {
			storageState: 'nothing'
		}
	},
	actions: {
		getUser() {
			/*await axios
                .get(URL + "api/v1/users")
                .then((response) => {
                    commit("setUser", response.data);
                })*/
		},
		login({ commit }, user) {
			return autenticacionService.login(user).then((response) => {
				let responseTmp = response;
				// console.log('responseTmp', responseTmp)
				if (responseTmp.Code == 200) {
					commit('setUser', responseTmp.Data);
					sesionService.setSesion(responseTmp); // .Data
					if (responseTmp.Data.perfil.passwordUpdated) sesionService.redirectHome();
					else sesionService.redirectFirstLogin();
					//sesionService.redirectHome() // .Data
				} else commit('setError', responseTmp);
				return responseTmp;
			});
		},
		logout() {
			window.location.replace('/login');
		}
	},
	mutations: {
		setUser(state, data) {
			state.user = data;

			//console.log("setUser => ", state.user);
		},
		setError(state, data) {
			state.error = data;
		},
		setLoginMessage(state, data) {
			state.loginMessage = data;
		}
	},
	getters: {
		getError: (state) => () => {
			return state.error;
		}
	}
};

/*export default class SesionService{
    loginUser({ commit }, user){
        axios
            .post(URL + "api/user/login", {
                email: user.email,
                password: user.password,
            })
            .then((response) => {
                if (response.data.access_token) {
                    localStorage.setItem("blog_token", response.data.access_token);
                    window.location.replace("/inicio");
                } else {
                    //se envie el error a la vista
                    commit("setLoginMessage", response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

}
*/
